import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Label = styled.label`
  font-size: 0.9375rem;
  font-weight: 600;
  color: ${Theme.colors.G_1};
`;

export const Select = styled.select`
  width: 100%;
  height: 2.5rem;
  padding: 0 0.75rem;
  font-size: 1rem;
  border: 0.0625rem solid ${Theme.colors.G_4};
  border-radius: 0.375rem;
  background-color: ${Theme.colors.WHITE};
  color: ${Theme.colors.BLACK};

  :focus {
    outline: none;
    border-color: ${Theme.colors.B_3};
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  border: 0.0625rem solid ${Theme.colors.G_4};
  border-radius: 0.375rem;
  resize: vertical;
  min-height: 8rem;

  :focus {
    outline: none;
    border-color: ${Theme.colors.B_3};
  }
`;

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledCheckbox = styled.input`
  width: 1.25rem;
  height: 1.25rem;
  cursor: pointer;
  accent-color: ${Theme.colors.B_3};
`;

export const CheckboxLabel = styled.label`
  font-size: 0.9375rem;
  color: ${Theme.colors.G_1};
  cursor: pointer;
  font-weight: 500;
`;

export const HelperText = styled.span`
  font-size: 0.8125rem;
  color: ${Theme.colors.G_2};
  margin-top: 0.25rem;
`;

export const ImageUploadArea = styled.div`
  border: 0.125rem dashed ${Theme.colors.G_4};
  border-radius: 0.5rem;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Theme.colors.G_7};
`;

export const FileInput = styled.input`
  display: none;
`;

export const FileLabel = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;

export const ImageList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 0.5rem;
`;

export const ImageItem = styled.div`
  position: relative;
  width: 6.25rem;
  height: 6.25rem;
`;

export const ImagePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.375rem;
  border: 0.0625rem solid ${Theme.colors.G_4};
`;

export const RemoveImgBtn = styled.button`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.25rem;
  font-size: 0.75rem;
  background-color: rgba(0, 0, 0, 0.6);
  color: ${Theme.colors.WHITE};
  border: none;
  cursor: pointer;
  border-radius: 0 0 0.375rem 0.375rem;

  :hover {
    background-color: rgba(0, 0, 0, 0.8);
  }
`;
